(() => {
  if (customElements.get('sc-recommended-addons')) return;
  class RecommendedAddons extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.closest('form');
      if (!this.form) return;
      this.initialized = true;
      this.bikes = JSON.parse(this.querySelector('[data-addon-bike-variants]').textContent);
      this.button = this.form.querySelector('[data-add-to-cart]');
      this.error = this.querySelector('[data-addon-error]');
      this.pending = false;
      this.onChange = () => { this.update(); setTimeout(() => this.update(), 0); };
      this.onSubmit = event => this.submit(event);
      this.onVariant = event => { if (this.bikes.some(v => v.id === event.detail?.variant?.id)) this.onChange(); };
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('input', this.onChange);
      this.form.addEventListener('submit', this.onSubmit, true);
      // Variant controls can be outside the form with a form attribute.
      this.container = this.form.closest('[data-product-id]') || this.form.closest('.shopify-section') || this.form;
      this.container.addEventListener('change', this.onChange);
      document.addEventListener('variant:change', this.onVariant);
      this.update();
      this.hidden = false;
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('input', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.container?.removeEventListener('change', this.onChange);
      document.removeEventListener('variant:change', this.onVariant);
      this.form?.classList.remove('sc-addons-selected');
      this.initialized = false;
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.dataset.currency}).format(cents / 100); }
    quantity() { const n = Number(new FormData(this.form).get('quantity') || 1); return Number.isInteger(n) && n > 0 ? n : 1; }
    selections() { return [...this.querySelectorAll('[data-addon-card]')].filter(card => { const check=card.querySelector('[data-addon-check]'); return check.checked && !check.disabled; }).map(card => card.querySelector('[data-addon-variant]').selectedOptions[0]).filter(option => option && option.dataset.available === 'true'); }
    update() {
      if (this.pending) return;
      for (const card of this.querySelectorAll('[data-addon-card]')) {
        const option = card.querySelector('select').selectedOptions[0];
        const check = card.querySelector('input');
        check.disabled = !option || option.dataset.available !== 'true';
        if (check.disabled) check.checked = false;
        card.querySelector('[data-addon-unavailable]').hidden = !check.disabled;
        if (option) {
          card.querySelector('[data-addon-price]').textContent = this.money(Number(option.dataset.price));
          card.querySelector('img').src = option.dataset.image;
        }
      }
      const chosen=this.selections(), qty=this.quantity();
      const sum=chosen.reduce((n,o)=>n+Number(o.dataset.price),0)*qty;
      const id=Number(new FormData(this.form).get('id'));
      const bike=this.bikes.find(v=>v.id===id);
      this.querySelector('[data-addon-count]').textContent='('+chosen.length+')';
      this.querySelector('[data-addon-subtotal]').textContent=this.money(sum);
      this.querySelector('[data-addon-total]').textContent=bike?this.money(bike.price*qty+sum):(this.bikes.some(v=>v.available)?'Choose bike options':'Bike currently sold out');
      this.form.classList.toggle('sc-addons-selected', chosen.length > 0);
    }
    async submit(event) {
      const chosen=this.selections();
      if (!chosen.length && !this.pending) return; // Keep the existing bike-only purchase path.
      event.preventDefault(); event.stopImmediatePropagation();
      if (this.pending || this.button?.disabled) return;
      const original=new FormData(this.form), id=original.get('id');
      const bike=this.bikes.find(v=>String(v.id)===String(id));
      if (!bike?.available) { this.showError('Please choose an available bike option.'); return; }
      this.pending=true;
      this.error.hidden=true;
      const qty=this.quantity(), payload=new FormData();
      payload.append('items[0][id]',id); payload.append('items[0][quantity]',String(qty));
      for (const [key,value] of original) {
        if (/^properties\[[^\]]+\]$/.test(key)) payload.append('items[0]['+key.replace('[',']['),value);
        else if (key==='selling_plan' && value) payload.append('items[0][selling_plan]',value);
      }
      chosen.forEach((o,i)=>{
        const prefix='items['+(i+1)+']';
        payload.append(prefix+'[id]',o.value);payload.append(prefix+'[quantity]',String(qty));
        if(o.dataset.service==='true'){
          const title=this.dataset.bikeTitle || 'Bike';
          payload.append(prefix+'[properties][For bike]',title+(bike.title && bike.title!=='Default Title'?' — '+bike.title:''));
          payload.append(prefix+'[properties][Service]','Local assembly only — arrange with Sun Chaser');
        }
      });
      const wasDisabled=this.button.disabled;
      this.button.disabled=true; this.button.classList.add('btn--loading'); this.form.setAttribute('aria-busy','true');
      const controls=[...this.querySelectorAll('input,select')].map(el=>[el,el.disabled]);
      controls.forEach(([el])=>el.disabled=true);
      const controller=new AbortController(), timer=setTimeout(()=>controller.abort(),25000);
      try {
        const response=await fetch(this.dataset.cartAdd,{method:'POST',body:payload,headers:{'X-Requested-With':'XMLHttpRequest'},signal:controller.signal});
        const data=await response.json();
        if (!response.ok || data.status) {
          const reason=typeof data.description==='string'?data.description:'An item is no longer available in the selected quantity.';
          this.showError(reason+' Check your cart before trying again.');
          return;
        }
        this.form.querySelector('.errors')?.remove();
        if (window.theme?.settings?.cartType==='drawer' && document.querySelector('#CartDrawer')) {
          this.form.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product:data.items?.[0] || data,items:data.items,addToCartBtn:this.button}}));
        } else window.location.assign(this.dataset.cartUrl);
      } catch {
        this.showError('We could not confirm the cart update. Please check your cart before trying again.');
      } finally {
        clearTimeout(timer); this.pending=false;
        controls.forEach(([el,disabled])=>el.disabled=disabled);
        const current=this.bikes.find(v=>String(v.id)===String(new FormData(this.form).get('id')));
        this.button.disabled=wasDisabled || !current?.available;
        this.button.classList.remove('btn--loading');this.form.removeAttribute('aria-busy');this.update();
      }
    }
    showError(message) { this.error.textContent=message;this.error.hidden=false;this.error.focus(); }
  }
  customElements.define('sc-recommended-addons', RecommendedAddons);
})();
